import React from 'react';
import Text from '../../../Text';
export const OnlineStatus = _ref => {
  let {
    children
  } = _ref;
  if (!children) {
    return null;
  }
  return React.createElement(Text.Caption, {
    tag: "p",
    className: "status"
  }, "online");
};